import { useQuery } from 'react-query';
import { users } from '../../../API/TT_ELD/Users/user';
import {
  dotRequestProgressApi,
  DotRequestProgressListParams,
} from '../../../API/TT_ELD/Users/dotRequestProgress';
import { TableParams } from '../../../Utils/TableTypes';

export const useUsersData = (
  companyId: undefined | string,
  role: undefined | string,
  status: boolean | undefined | null,
  driverName: any,
  driverEmail: undefined | string,
  userName?: undefined | string,
  licenseNumber?: undefined | string | number,
  uid?: string,
  companyUID?: string,
  tableParams?: TableParams,
  publicId?: string | number,
  allowedIntegration?: boolean,
) => {
  return useQuery(
    [
      `users/${driverName || 'all'}`,
      companyId,
      role,
      status,
      driverName,
      driverEmail,
      userName,
      licenseNumber,
      uid,
      companyUID,
      tableParams,
      publicId,
      allowedIntegration,
    ],
    () =>
      users.read(
        companyId,
        role,
        status,
        driverName,
        driverEmail,
        userName,
        licenseNumber,
        uid,
        companyUID,
        tableParams,
        publicId,
        allowedIntegration,
      ),
    { refetchOnWindowFocus: false },
  );
};

export const useUserData = (userId: number | string | undefined) => {
  return useQuery([`users/${userId}`, userId], () => users.userData(userId), {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};

export const useTrackingRang = (
  skip: string | number,
  date: string | number | any,
  driverId: string | undefined,
) => {
  return useQuery(
    [`admin/report${skip || 'all'}`, skip, date, driverId],
    () => users.trackingByRang(skip, date, driverId),
    { refetchOnWindowFocus: false },
  );
};

export const useDotRequestProgressList = (params: DotRequestProgressListParams) => {
  return useQuery(
    ['dot-request-progress-list', params?.page, params?.perPage, params?.driverUid],
    () => dotRequestProgressApi.list(params),
    {
      refetchOnWindowFocus: false,
      enabled: !!params?.driverUid,
    },
  );
};

export const useDotRequestProgressSession = (
  sessionId: string | number | undefined,
  enabled = true,
) => {
  return useQuery(
    ['dot-request-progress-session', sessionId],
    () => dotRequestProgressApi.session(sessionId),
    {
      enabled: enabled && !!sessionId,
      refetchOnWindowFocus: false,
    },
  );
};
